import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import style from './Form.css';

const Form = ({
  title,
  isLoading,
  loadingMessage,
  errorMessage,
  onFormSubmit,
  cancel,
  onFormCancel,
  children
}) => (
  <div className="container">
    <div className={style.container}>
      <div className="row justify-content-center">
        <div className={"col-sm-10 col-md-7 col-lg-5 " + style.panel}>
          <div
            className={cx(
              'panel',
              'panel-default',
              'text-center',
              style.cardBackground
            )}
          >
            <div className="panel-body">
              {isLoading ? (
                <div>{loadingMessage}</div>
              ) : (
                <div>
                  {errorMessage && (
                    <div className="alert alert-danger" role="alert">
                      {errorMessage}
                    </div>
                  )}
                  <form onSubmit={onFormSubmit}>
                    {children}
                    {cancel ? (
                      <div className="justify-content-center">
                        <button
                          className={cx('btn', 'btn-primary', style.button)}
                          type="submit"
                        >
                          {title}
                        </button>
                        <button
                          className={cx('btn', 'btn-primary', style.button)}
                          type="button"
                          onClick={onFormCancel}
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <button className={cx('btn', 'btn-primary', style.button)} type="submit">
                        {title}
                      </button>
                    )}
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

Form.propTypes = {
  cancel: PropTypes.bool,
  onFormCancel: PropTypes.func,
  title: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  loadingMessage: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  onFormSubmit: PropTypes.func.isRequired,
  children: PropTypes.arrayOf(PropTypes.element).isRequired
};

Form.defaultProps = {
  cancel: false,
  onFormCancel: null,
  errorMessage: ''
};

export default withStyles(style)(Form);



// WEBPACK FOOTER //
// ./src/components/Form/Form.js